
export const checkout = {
  thankYou: {
    header: "Köszönjük a vásárlást!",
    content: {
      emailSent: "A másolat elküldve ide:",
      download: "Letöltés"
    },
    consultation: {
      title: "A konzultáció időpontja:",
      details: "Az időpont részleteit és a csatlakozási linket elküldtük emailben ide:"
    },
    video: {
      title: "Várható elkészülés:",
      details: "Amint elkészül a videód, emailben értesítünk ide:"
    },
    question: {
      title: "Köszönjük a kérdésed!",
      response: "24 órán belül válaszolunk a kérdésedre",
      email: "A választ emailben is megkapod ide:"
    }
  },
  form: {
    error: {
      title: "Hiba",
      requiredFields: "Kérjük, töltsd ki a kötelező mezőket"
    }
  }
};
